export const encryApiList = [
  "/api/v6/coupons/mis/totalnum",
  "/api/v5/document/dict/GetSelectedDict",
  "/api/v5/comment/show/list",
  "/api/v5/comment/show/commentCountByScoreClassify",
  "/api/v5/comment/show/commentCountGroupByTag",
  "/api/v5/oss/token",
  "/api/v5/document/login",
  "/api/v5/product/getuserproducts",
  "/api/v5/orderreport/list",
  "/api/v5/orderreport/replylist",
  "/api/v5/orderreport/reminders",
  "/api/v5/orderreport/create",
  "/api/v5/orderreport/supplement",
  "/api/v5/orderreport/close",
  "/api/v6/document/tech/login",
  "/api/v6/document/partner/login",
  "/api/v5/item/order/getItemOrderDetail",
  "/api/v5/item/order/getItemOrderList",
  "/api/v5/document/wallect/getIncomeList",
  "/api/v5/document/technician/tec/getUserBankCardList",
  "/api/v5/document/technician/tec/addBankCard",
  "/api/v5/document/technician/tec/delBankCard",
  "/api/v5/document/wallect/getQueryTreeForIncomeList",
  "/api/v5/document/wallect/withdraw",
  "/api/v5/document/wallect/modifyWithdrawPwd",
  "/api/v6/document/wallet/getWithdrawAccount",
  "/api/v5/document/account/GetProtocol",
  "/api/v5/document/account/sign",
  "/api/v5/document/technician/tec/getUserBankCardList",
  "/api/v5/document/technician/tec/switchBankCard",
  "/api/v5/document/technician/tec/quickWithdrawCheck",
  "/api/v6/document/wallet/withdrawMoney",
  "/api/v5/sms/send",
  "/api/v5/sms/validate",
  "/api/v5/document/technician/tec/updateOnOffLine",
  "/api/v5/document/userinfo",
  "/api/v5/item/order/technicianDeleteOrder",
  "/api/v5/document/technician/tec/GetBaseInfo",
  "/api/v5/document/technician/tec/commitBaseInfo",
  "/api/v5/manager/merchantCreditScore/getMerchantCreditScoreList",
  "/api/v5/manage/tec/report/statistics",
  "/api/v6/order/customer/personas",
  "/api/v5/sms/captcha",
  "/api/v5/sms/captchaValidate",
  "/api/v5/manage/tec/report/viewInstruction",
  "/api/v5/document/invite/reg",
  "/api/v5/document/technician/tec/modPhone"
];
